import { useFlags } from '@joor/launchdarkly-react-client-sdk'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { fromGlobalId } from 'utils/transformations/graphql'

import { EMPTY_CELL_CONTENT } from 'shop/products/utils'

import { LinesheetCellValue, TableRowData } from '../joorPayOrders.types'

export function LinesheetCell({
  value,
  data,
}: {
  value: LinesheetCellValue
  data: TableRowData
}) {
  const { newCollectionsEditAndCreate } = useFlags()
  const { id = '', name = '' } = value

  if (!id) return <>{EMPTY_CELL_CONTENT}</>

  const to = newCollectionsEditAndCreate
    ? `/ra/linesheet/${fromGlobalId(id).id}`
    : `/collections/view/${fromGlobalId(id).id || ''}?brandId=${
        fromGlobalId(data.brandId).id
      }`

  return (
    <StyledLink to={to} target="_blank">
      {name}
    </StyledLink>
  )
}

const StyledLink = styled(Link)`
  color: var(--color-secondary-800) !important;
`
